import React, { useCallback } from 'react';
import { useFilterSettings } from '@perxis-auto/instock-sdk/lib/features/filterChoice';
import { useAppSelector } from '@perxis-auto/instock-sdk/lib/shared/lib/store';
import { selectors as configSelectors } from '@perxis-auto/instock-sdk/lib/shared/store/config';
import { usePageReady } from '@perxis-auto/instock-sdk/lib/shared/store/installation';
import { EventService } from '@perxis-auto/shared';

import { AppConstructor } from '@/app/appConstructor';
import { APP_EVENTS } from '@/shared/config';
import { PAGES } from '@/shared/config/pages';
import { SEO } from '@/shared/ui/seo';

import { ModelsProps } from './Models.types';

export function Models(props: ModelsProps) {
  const layouts = useAppSelector(configSelectors.selectLayout);

  const layout = layouts?.[PAGES.Models];

  const handlePageReady = useCallback(() => {
    EventService.getInstance().sendEvent(APP_EVENTS.ModelsPageVisited);
  }, []);

  useFilterSettings();

  usePageReady({
    onReady: handlePageReady,
  });

  if (!layout) {
    return null;
  }

  return (
    <>
      <SEO title="Страница выбора моделей" />
      <AppConstructor layout={layout!} />
    </>
  );
}
